import axios from "axios";
import config from "../config";
import type { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type ReferralDashboard = {
  referral_code?: string;
  referral_url?: string;
  /** Compatibilidade com o contrato Laravel atualmente publicado. */
  code?: string;
  link?: string;
  referred_count: number;
  rewards_granted: number;
};

export const getReferral = (): Promise<ApiSuccess<ReferralDashboard>> =>
  axios.get(apiBase + "/referral");
